var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('Toolbar',{attrs:{"icon":'searchCheck',"title":'History'}}),_c('ProductTable',{attrs:{"columns":_vm.columns,"rows":_vm.history}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }